<template>
  <SectionGroup gap="larger">
    <FormSection title="Специализация">
      <SpecsPicker
        :groups="groups"
        :selected-categories="filters.s"
        :s-options="options.s"
        :allow-select-group="true"
        v-model="filters.s"
        :max-selected-categories-count="null"
      />
    </FormSection>

    <FormSection title="Квалификация">
      <BasicSelect
        v-model="filters.qualification"
        :options="options.qualification"
      />
    </FormSection>

    <FormSection title="Профессиональные навыки">
      <SkillsPicker
        v-model="filters.skills"
        :skills.sync="dynamicOptions.skills"
      />
    </FormSection>

    <FormSection title="Зарплата">
      <InputGroup direction="vertical" gap="medium">
        <PriceInputGroup
          v-model="filters.salary"
          placeholder="От"
          :currency.sync="filters.currency"
          :currency-options="options.currency"
        />
        <BasicCheckbox
          v-model="filters.hasSalary"
          :value="1"
          :false-value="null"
        >
          Указана
        </BasicCheckbox>
      </InputGroup>
    </FormSection>

    <FormSection title="Местоположение">
      <LocationPicker
        v-model="filters.locations"
        multiple
        :locations.sync="dynamicOptions.locations"
      />
    </FormSection>

    <FormSection title="Тип занятости">
      <InputGroup direction="vertical" gap="medium">
        <BasicSelect
          v-model="filters.employment"
          :options="options.employment"
        />
        <BasicCheckbox
          v-model="filters.remoteWork"
          :value="1"
          :false-value="null"
        >
          Можно удалённо
        </BasicCheckbox>
      </InputGroup>
    </FormSection>

    <FormSection title="Компания">
      <InputGroup direction="vertical" gap="medium">
        <BasicCheckbox
          v-model="filters.has_accreditation"
          :value="1"
          :false-value="null"
        >
          Аккредитованные ИТ-компании
        </BasicCheckbox>
        <CompanyPicker
          v-model="filters.company"
          :disabled="hasAccreditation"
          :companies.sync="dynamicOptions.company"
        />
        <BasicCheckbox
          v-model="filters.excludeCompany"
          :disabled="hasAccreditation"
          :value="1"
          :false-value="null"
        >
          Исключить из поиска
        </BasicCheckbox>
      </InputGroup>
    </FormSection>

    <slot name="controls" />
  </SectionGroup>
</template>

<script>
import BasicCheckbox from 'src/components/form/BasicCheckbox/BasicCheckbox.vue';
import BasicSelect from 'src/components/form/BasicSelect/BasicSelect.vue';
import FormSection from 'src/components/form/FormSection/FormSection.vue';
import InputGroup from 'src/components/form/InputGroup/InputGroup.vue';
import PriceInputGroup from 'src/components/form/PriceInputGroup/PriceInputGroup.vue';
import CompanyPicker from 'src/components/pickers/CompanyPicker/CompanyPicker.vue';
import LocationPicker from 'src/components/pickers/LocationPicker/LocationPicker.vue';
import SkillsPicker from 'src/components/pickers/SkillsPicker/SkillsPicker.vue';
import SpecsPicker from 'src/components/pickers/SpecsPicker/SpecsPicker.vue';
import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';

export default {
  name: 'VacancyFilters',
  components: {
    BasicSelect,
    FormSection,
    SectionGroup,
    InputGroup,
    CompanyPicker,
    LocationPicker,
    SkillsPicker,
    PriceInputGroup,
    BasicCheckbox,
    SpecsPicker,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    dynamicOptions: {
      type: Object,
      required: true,
    },
    groups: {
      type: Array,
      required: true,
    },
  },
  watch: {
    filters: {
      handler(value) {
        this.$emit('change', value);
      },
      deep: true,
    },
    hasAccreditation: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.filters.company = null;
          this.filters.excludeCompany = null;
        }
      },
    },
  },
  computed: {
    hasAccreditation() {
      return !!this.filters.has_accreditation;
    },
  },
};
</script>
